import { useEffect, useMemo, useState } from "react";
import fetchUtil from "../utils/fetchUtil";

const useLatestNews = (enabled: boolean, excludeId?: string | number) => {
  const [latestNews, setLatestNews] = useState<Array<any>>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    setIsLoading(true);
    fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/blogs?_sort=date:DESC&_start=0&stu_dest_categories.category=News`, "GET", {}, "", false).then(
      (res: any) => {
        setLatestNews(res);
        setIsLoading(false);
      },
    );
  }, [enabled]);

  const filteredNews = useMemo(() => (excludeId == null ? latestNews : latestNews.filter((news) => news?.id !== excludeId)), [latestNews, excludeId]);

  return { latestNews: filteredNews, isLoading };
};

export default useLatestNews;
